import type {Properties} from '../services/rest'

export const getPropertyFromList = (
  name: string,
  properties: Properties | null | undefined,
): string | null | undefined => properties?.property?.find(prop => prop.name === name)?.value
